// theme.js
import { createTheme } from "@mui/material/styles";
import KaribuNarrow from "./assets/fonts/karibu-narrow-bold.ttf";

// const _theme = createTheme({
//   palette: {
//     mode: "light", // or 'dark' depending on your design

//     primary: {
//       main: "#FF0000", // Bold red (primary action)
//       dark: "#C62828", // Darker red (hover/active)
//       contrastText: "#FFFFFF", // White text on red
//     },

//     secondary: {
//       main: "#FFC107", // Warm yellow/gold (accent)
//       contrastText: "#000000", // Black text on yellow
//     },

//     background: {
//       default: "#F9F9F9", // Light neutral background
//       paper: "#FFFFFF", // For cards, dialogs, etc.
//     },

//     text: {
//       primary: "#333333", // Dark gray text
//       secondary: "#666666", // For subtitles, hints, etc.
//     },

//     // Optional: error, warning, info, success
//     error: {
//       main: "#D32F2F",
//     },
//     warning: {
//       main: "#FFA000",
//     },
//     info: {
//       main: "#0288D1",
//     },
//     success: {
//       main: "#388E3C",
//     },
//   },
//   typography: {
//     fontFamily: "Titillium Web",
//     button: {
//       textTransform: "none", // Optional: Remove uppercase
//     },
//   },
//   // typography: {
//   //   fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   //   button: {
//   //     textTransform: "none", // Optional: Remove uppercase
//   //   },
//   // },

//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//         },
//       },
//     },
//   },
// });

const theme = createTheme({
  palette: {
    primary: {
      //dark: "#E63946", // Vermelho Morango
      dark: "#f4671bff", // Vermelho Morango
      //main: "#B71C1C", // Vermelho Framboesa
      main: "#F8AE15", // Vermelho Framboesa
      light: "#F48FB1", // Rosa Suave
      contrastText: "#FFF1E6", // Creme (para textos sobre fundo vermelho)
    },
    secondary: {
      main: "#575757", // Chocolate Claro
      contrastText: "#FFF1E6",
    },
    // background: {
    //   default: "#FFF1E6", // Creme Baunilha
    //   paper: "#FFFFFF",
    // },
    text: {
      primary: "#3E2723", // marrom mais forte para contraste
      secondary: "#8D6E63", // chocolate claro
    },
  },
  typography: {
    fontFamily: "'Poppins', 'Roboto','Titillium Web', sans-serif",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
  typography: {
    fontFamily: "'Karibu Narrow', Arial, sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Karibu Narrow';
          src: url(${KaribuNarrow}) format('truetype');
          font-weight: 600;
          font-style: normal;
          font-display: swap;
        }
      `,
    },
  },
});

const _theme = createTheme({
  typography: { fontFamily: "Titillium Web" },

  palette: {
    //mode: "dark",
    secondary: {
      // Purple and green play nicely together.
      main: "#021526",
    },

    primary: {
      // This is green.A700 as hex.
      main: "#03346E",
    },
    text: { secondary: "#8e8e8e" },
  },
});

export default theme;
